import app from '../app.first';
import { intersectionBy } from 'lodash';

app.SearchCandidates = class extends app.Component {
    onReady () {
        this.numSelected = 0;

        $('.count-name').on('classChange', function() {
            $(".search-results-container").removeClass('hide');
       });

        $('#is-citizen').on('change', function (e) {
            if ($(e.delegateTarget).is(':checked')) {
                $('#has-work-permit-1').closest('.radio').hide();
            } else {
                $('#has-work-permit-1').closest('.radio').show();
            }
        }).trigger('change');

        $('#province-ids').on('change', function (e) {
            $('.postal-container').show();
        });

        /**
         * Salary range filters
         */
        $('#min-salary, #max-salary').parent().append('<span></span>');
        $('#min-salary, #max-salary').on('input', e => {
            const $input = $(e.target);
            $input.siblings('span').text('R' + $input.val().toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","));
        }).trigger('input');

        /**
         * If matric is selected, show subjects filter.
         * If tertiary is selected, show fields of study filter
         */
        $('#qualification-level-ids').on('change', e => {
            const selectedLevelIds = $(e.target).val();

            if (intersectionBy(selectedLevelIds, [4], parseInt).length < 1)
                this.$el.find('[data-matric-subjects]').prop('disabled', true).parents('.input').hide();
            else
                this.$el.find('[data-matric-subjects]').prop('disabled', false).parents('.input').show();

            if (intersectionBy(selectedLevelIds, [5,6,7,8,9], parseInt).length < 1)
                this.$el.find('[data-fields-of-study]').prop('disabled', true).parents('.input').hide();
            else
                this.$el.find('[data-fields-of-study]').prop('disabled', false).parents('.input').show();
        }).trigger('change');

        /**
         * Apply baseline, enable/disable select
         */
        $('#apply-baseline').change(() => {
            $('#baseline-id').prop("disabled", !$('#apply-baseline').is(':checked'));
        });

        /**
         * Apply campaign, enable/disable select
         */
        $('#apply-campaign').change(() => {
            $('#campaign-id').prop("disabled", !$('#apply-campaign').is(':checked'));
        });

        /**
         * Apply job role filter, enable/disable years select
         */
        this.$el.find('#job-role').on('change', e => {
            this.$el.find('#job-role-years').prop('disabled', $(e.target).val().length < 1);
        });

        /**
         * Language filter, enable/disable fluency
         */
        this.$el.find('#language-ids').on('change', e => {
            this.$el.find('#fluency').prop('disabled', $(e.target).val().length < 1);
        });

        /**
         * candidates selected
         */
        this.$el.find('.candidate-id').on('change', async e => {
            let $parentRow = $(e.target).parents('tr.candidate-data');
            let candidateId = $parentRow.data('candidateId');
            let $mobileCandidateContainer = this.$el.find(`.card-mobile-table [data-candidate-id="${candidateId}"]`);

            let result = await app.ajax(
                `/recruiter/search/select-candidate/${candidateId}.json`,
                { selected: e.target.checked },
                false
            );

            if (result && result.selected) {
                $parentRow.addClass('is-selected');
                $mobileCandidateContainer.addClass('is-selected');
            } else {
                e.target.checked = false;
                $parentRow.removeClass('is-selected');
                $mobileCandidateContainer.removeClass('is-selected');
            }

            $(document).trigger('Recruiter.Search.selectedCandidates.change');
        });

        this.$el.find('.candidate-mobile-photo').on('click', e => {
            let $el = $(e.target);
            let candidateId = $el.parents('.person-data').data('candidateId');

            let $mainCandidateInput = $(`.main-candidate-table [data-candidate-id="${candidateId}"] .candidate-id`);
            $mainCandidateInput.prop('checked', !$mainCandidateInput.is(':checked')).trigger('change');
        });

        $('#filter_specific_candidate').select2({
            width: '100%',
            minimumResultsForSearch: -1,
            minimumInputLength: 3,
            ajax: {
                url: '/ajax/search-candidates',
                dataType: 'json',
                processResults: function (data) {
                    return {
                        results: data
                    };
                },
            }
        });

        $("#save-filter-form").on("submit", function(e){
            e.preventDefault();

            if ($('#filter_name').val() != "") {
                $.ajax({
                    url: "/ajax/save-filter",
                    data: $('#save-filter-form').serialize(),
                    method: 'POST',
                    beforeSend: (xhr) => {
                        xhr.setRequestHeader('X-CSRF-Token', $('[name="_csrfToken"]').val());
                    },
                    success: response => {
                        $('#filter-modal-close-btn').trigger('click');
                        $('#add-filter').addClass('hidden');
                        $('#remove-filter').removeClass('hidden');
                        if (response.success) {
                            $('#remove-filter').attr('data-filter-id', response.filter_id);
                        }

                        setTimeout(
                            function(){
                                alert(response.message)
                            },
                        500);
                    }
                });
            }
        });

        $(".remove-favorite-filter").on("click", function(e){
            $.ajax({
                url: "/ajax/remove-filter",
                data: {
                    filter_id: $(this).attr('data-filter-id')
                },
                method: 'POST',
                beforeSend: (xhr) => {
                    xhr.setRequestHeader('X-CSRF-Token', $('[name="_csrfToken"]').val());
                },
                success: response => {
                    $('#filter-modal-close-btn').trigger('click');

                    $('#add-filter').removeClass('hidden');
                    $('#remove-filter').addClass('hidden');

                    setTimeout(
                        function(){
                            alert(response.message)
                        },
                    500);
                }
            });
        });

        $("#csv-file-input").change(function(e){
            var formData = new FormData();
            formData.append('csv_file', $('#csv-file-input')[0].files[0]);
            $('.apply-filter').prop('disabled', true);
            $.ajax({
                url: "/ajax/upload-csv",
                data: formData,
                method: 'POST',
                processData: false,
                contentType: false,
                beforeSend: (xhr) => {
                    xhr.setRequestHeader('X-CSRF-Token', $('[name="_csrfToken"]').val());
                },
                success: response => {
                    $('#uploaded_ids').val(response.file.url);
                }
            });

            $('.apply-filter').prop('disabled', false);
        });

        $('.btn-remove-file-csv').click(function(e){
            $('.csv-file-input').removeClass('d-none');
            $('.csv-file-link').addClass('d-none');
            $('#uploaded_ids').val('');
        });
    }
}